// src/components/common/ReturnButton.tsx
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRotateLeft } from '@/icons';
import './ReturnButton.css';

interface ReturnButtonProps {
  onClick: () => void;
  disabled?: boolean;
  className?: string;
  label?: string;
}

const ReturnButton: React.FC<ReturnButtonProps> = ({
  onClick,
  disabled = false,
  className = '',
  label = 'Devolver',
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`return-button ${className}`}
    >
      <FontAwesomeIcon icon={faRotateLeft} /> {label}
    </button>
  );
};

export default ReturnButton;
